module.exports = ".pajak-keluaran-card-wizard {\n    width: 600px;\n    height: 340px;\n    margin-top: -100px;\n}\n.drop-zone {\n    width: 99%;\n    height: 150px;\n    -webkit-box-sizing: content-box;\n    box-sizing: content-box;\n    border: 3px dashed rgba(0,136,226,0.91);\n    border-radius: 9px;\n    font: normal 16px/1 \"Times New Roman\", Times, serif;\n    color: rgba(255,255,255,1);\n    text-align: center;\n    text-overflow: ellipsis;\n  }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/faktur-pajak-keluaran/faktur-pajak-keluaran.component.css
// module id = ./src/app/faktur-pajak-keluaran/faktur-pajak-keluaran.component.css
// module chunks = main